/**
 * The five 75:2 section components' own loading skeletons, composed once. `Account.tsx` uses this
 * for its own loading branch; `NoSelection.tsx` (299:10749) reuses the exact same component for
 * its skeleton block below the picker card, per the frame -- not a second hand-drawn layout.
 */

import type { ReactNode } from 'react';

import { CommentSentimentSkeleton } from './CommentSentiment';
import { KpiRowSkeleton } from './KpiRow';
import { PublicationsSkeleton } from './Publications';
import { ReachOverTimeSkeleton } from './ReachOverTime';
import { TopicsSkeleton } from './Topics';

export function AccountSectionsSkeleton(): ReactNode {
  return (
    <div className="flex w-full flex-col gap-4">
      <KpiRowSkeleton />
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <div className="flex flex-col gap-4">
          <ReachOverTimeSkeleton />
          <PublicationsSkeleton />
        </div>
        <div className="flex flex-col gap-4">
          <CommentSentimentSkeleton />
          <TopicsSkeleton />
        </div>
      </div>
    </div>
  );
}
